export { default as BaseText } from './BaseText';
